/*
 * Babee Reshinee
 * Horizon 990px scroll-container handoff
 *
 * Horizon switches the vertical scroll container at 990px:
 *
 * < 990px:
 * document.scrollingElement
 *
 * >= 990px:
 * .page-wrapper
 *
 * Preserve the current scroll position when the viewport
 * crosses that internal Horizon breakpoint.
 */

const brScrollContainerMedia =
  window.matchMedia(
    '(min-width: 990px)'
  );

const brDocumentScroller =
  document.scrollingElement ??
  document.documentElement;

const brPageWrapper =
  document.querySelector(
    '.page-wrapper'
  );

if (brPageWrapper) {
  let documentScrollTop =
    brScrollContainerMedia.matches
      ? 0
      : brDocumentScroller.scrollTop;

  let pageWrapperScrollTop =
    brScrollContainerMedia.matches
      ? brPageWrapper.scrollTop
      : 0;

  const clampScrollTop = (
    element,
    value
  ) => {
    const maxScrollTop =
      Math.max(
        0,
        element.scrollHeight -
          element.clientHeight
      );

    return Math.min(
      Math.max(0, value),
      maxScrollTop
    );
  };

  const captureDocumentScroll =
    () => {
      /*
       * Only capture while document
       * is the active scroll container.
       *
       * This is important during the
       * breakpoint transition: once
       * 990px is active, a browser
       * layout reset must not overwrite
       * the last mobile position.
       */
      if (
        !brScrollContainerMedia.matches
      ) {
        documentScrollTop =
          brDocumentScroller.scrollTop;
      }
    };

  const capturePageWrapperScroll =
    () => {
      /*
       * Only capture while page-wrapper
       * is the active scroll container.
       */
      if (
        brScrollContainerMedia.matches
      ) {
        pageWrapperScrollTop =
          brPageWrapper.scrollTop;
      }
    };

  document.addEventListener(
    'scroll',
    captureDocumentScroll,
    {
      passive: true
    }
  );

  brPageWrapper.addEventListener(
    'scroll',
    capturePageWrapperScroll,
    {
      passive: true
    }
  );

  brScrollContainerMedia.addEventListener(
    'change',
    (event) => {
      const targetScrollTop =
        event.matches
          ? documentScrollTop
          : pageWrapperScrollTop;

      /*
       * Wait until the Horizon 990px
       * media-query styles have been
       * applied before transferring
       * the position.
       */
      window.requestAnimationFrame(
        () => {
          if (event.matches) {
            /*
             * document → page-wrapper
             */
            brDocumentScroller.scrollTop =
              0;

            brPageWrapper.scrollTop =
              clampScrollTop(
                brPageWrapper,
                targetScrollTop
              );

            pageWrapperScrollTop =
              brPageWrapper.scrollTop;
          } else {
            /*
             * page-wrapper → document
             */
            brPageWrapper.scrollTop =
              0;

            brDocumentScroller.scrollTop =
              clampScrollTop(
                brDocumentScroller,
                targetScrollTop
              );

            documentScrollTop =
              brDocumentScroller.scrollTop;
          }
        }
      );
    }
  );
}